import Vue from "vue";
import moment from "moment";
import { bus } from "../../../../main";

import lastDiagnosticDetail from "./detail/last-diagnostic-detail.vue";

import helpers from "../../../../shared/fleetbox-helpers";

export default {
	components: {
		lastDiagnosticDetail: lastDiagnosticDetail
	},
	data: function() {
		return {
			//#region filters
			filters: [
				{
					id: "timerange",
					items: [],
					value: {
						period: "0",
						startRange: moment(),
						endRange: moment()
					}
				},
				{
					id: "divisions",
					items: [],
					value: []
				},
				{
					id: "groups",
					items: [],
					value: []
				},
				{
					id: "vehicles",
					items: [],
					value: []
				},
				{
					id: "drivers",
					items: [],
					value: []
				},
				{
					id: "diagnosis-type",
					items: [],
					value: {
						information: false,
						anomaly: true
					}
				}
			],
			//#endregion filters

			isDetailLoading: false,

			reportName: ""
		};
	},

	created() {
		var self = this;
		//#region filters
		this.filters[0].value.startRange = moment()
			.add(-7, "days")
			.startOf("day");
		this.filters[0].value.endRange = moment().endOf("day");
		//#endregion filters

		bus.$emit("show-spinner-loading");

		helpers.getReportName().then(res => {
			if (res) {
				var report = res.find(item => {
					return item.id == 270;
				});

				if (report) {
					self.reportName = report.name;
				}
				else {
					self.reportName = "Ultime rilevazioni diagnostica/allarmi";
				}
			}
		});
	},
	mounted() {},

	watch: {
		isDetailLoading: {
			handler: function() {
				this.loadingProgressUpdate();
			}
		}
	},

	methods: {
		//#region loading progress
		loadingProgressUpdate() {
			if (this.isDetailLoading) {
				bus.$emit("show-spinner-loading");
			}
			else {
				bus.$emit("hide-spinner-loading");
			}
		},
		onDetailLoading(isLoading) {
			this.isDetailLoading = isLoading;
		},
		//#endregion
		//#region filters events
		onFilterApplyClick() {
			if (this.$refs.lastDiagnosticDetailReport) {
				this.$refs.lastDiagnosticDetailReport.applyReportFilter();
			}
		},
		onFilterResetClick() {
			this.setDefaultFilters();
			this.onFilterApplyClick();
		},
		onFilterDriverChange(newValue) {
			var driverFilter = this.filters.find(item => {
				return item.id == "drivers";
			});
			if (driverFilter) {
				Vue.set(driverFilter, "value", newValue);
			}
		},
		onFilterTimerangeChange(newValue) {
			var timeRangeFilter = this.filters.find(item => {
				return item.id == "timerange";
			});
			if (timeRangeFilter) {
				timeRangeFilter.value.startRange = moment(newValue.startDate);
				timeRangeFilter.value.endRange = moment(newValue.endDate);
			}
		},
		onFilterDivisionChange(newValue) {
			var divisionFilter = this.filters.find(item => {
				return item.id == "divisions";
			});
			if (divisionFilter) {
				Vue.set(divisionFilter, "value", newValue);
			}
		},
		onFilterGroupChange(newValue) {
			var groupFilter = this.filters.find(item => {
				return item.id == "groups";
			});
			if (groupFilter) {
				Vue.set(groupFilter, "value", newValue);
			}
		},
		onFilterPlateChange(newValue) {
			var vehiclesFilter = this.filters.find(item => {
				return item.id == "vehicles";
			});
			if (vehiclesFilter) {
				Vue.set(vehiclesFilter, "value", newValue);
			}
		},
		onDiagnosisTypeChange(newValue) {
			var diagnosisTypeFilter = this.filters.find(item => {
				return item.id == "diagnosis-type";
			});
			if (diagnosisTypeFilter) {
				Vue.set(diagnosisTypeFilter, "value", newValue);
			}
		},
		setDefaultFilters() {
			this.filters[0].value.period = "0";
			this.filters[0].value.startRange = moment()
				.add(-7, "days")
				.startOf("day");
			this.filters[0].value.endRange = moment().endOf("day");

			for (var i = 1; i < this.filters.length - 1; i++) {
				var flt = this.filters[i];

				Vue.set(flt, "value", []);
			}

			this.filters[5].value.information = false;
			this.filters[5].value.anomaly = true;
		}
		//#endregion filters events
	},
	computed: {}
};
